import React from "react";
import ProductTable from "../ProductTable/ProductTable";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faThLarge} from "@fortawesome/free-solid-svg-icons";
import "./CompanySections.css";
function CompanyProducts() {
  return (
    <>
      <div className="company__details">
        <h4 className="p-icon">
          <FontAwesomeIcon icon={faThLarge} size="sm" />
          Products Details
        </h4>
        <div className="products__details__container">
          <ProductTable />
        </div>
      </div>
    </>
  );
}

export default CompanyProducts;
